/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useEnvContext, useWebStoreContext } from "contexts";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { PBV3RewardClaimStatus, RewardClaimStatuses } from "interfaces";
import {
	onClosePopUp,
	onPBV3change,
	selectPoisBountyV3State
} from "redux/slices";
import { nFormatter } from "utils/number-formatter";
import { getTimeLeft } from "utils/time";
import {
	Background,
	Body,
	Button,
	Container,
	Header,
	Icon,
	Reward,
	RewardImg,
	RewardText,
	Title
} from "./styles";

interface PBRewardCollectedProps {}

export const PBRewardCollected: React.FC<PBRewardCollectedProps> = () => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { nowTime } = useWebStoreContext();
	const scale = useCalculateScale(400, 500);
	const { isFeatureFlagEnabled } = useEnvContext();
	const { getImage: getImageLocal } = useImagePath("local");
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const {
		tracker: pb3Tracker,
		rewards: pb3Rewards,
		rewardCollected: pb3RewardCollected
	} = useAppSelector(selectPoisBountyV3State);

	const rewards = pb3Rewards;
	const lastReward = rewards?.findLast(
		(r: PBV3RewardClaimStatus | RewardClaimStatuses) => r.isClaimed === true
	);

	const onClose = () => {
		dispatch(onClosePopUp());
		if (isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2)) {
			const timeLeft = getTimeLeft(nowTime, pb3Tracker?.endTime, "seconds");
			const timeTotal =
				getTimeLeft(pb3Tracker?.startTime, pb3Tracker?.endTime, "seconds") ||
				undefined;
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "reward_claimed_popup_clicked",
				event_type: "pois_bounty_v3",
				action: "reward_claimed_popup_clicked",
				source: "pois_bounty_menu",
				type:
					pb3Tracker?.eventType === "user" ? "personal" : pb3Tracker?.eventType,
				time_left: timeLeft,
				time_total: timeTotal,
				event_id: pb3Tracker?.eventId,
				reward_id: lastReward?.reward?.rewardId ?? ""
			});
		}
		dispatch(onPBV3change({ rewardCollected: undefined }));
	};

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onClose} />
			<Header>
				<Background
					src={getImage(poisBountyAssets.v3.rewardCollected.background)}
				/>
				<Reward
					isPbv3={!!pb3Rewards}
					data-image={
						pb3Rewards
							? getImage(poisBountyAssets.v3.rewardCollected.shine)
							: getImage(poisBountyAssets.progress.rewardBackground)
					}
				>
					<Icon>
						<img
							src={getImageLocal(
								"/spec_pois_bounty/pois_bounty_icon_check.png"
							)}
						/>
					</Icon>
					<RewardImg src={pb3RewardCollected?.imageUrl} />
					{pb3RewardCollected?.rewardAmount && (
						<RewardText>
							x{nFormatter(Number(pb3RewardCollected?.rewardAmount))}
						</RewardText>
					)}
				</Reward>
			</Header>
			<Body>
				<Title style={{ paintOrder: "stroke fill" }}>
					Your Poi’s Bounty reward items are waiting in your in-game inbox to be
					collected.
				</Title>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */
						display="flex"
						justifyContent="center"
					>
						<Button
							themeColor="secondary"
							onClick={onClose}
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
						>
							Continue
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="pois_bounty_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
